import action from '../commons/templateActionStatus';

export const getAllTemplateRequestAction = () => {
    return {
        type: action.GET_ALL_TEMPLATES_REQUEST,
        status: 'GET_ALL_TEMPLATES_REQUEST',
        requestState: true,
    };
};

export const getAllTemplateSuccessAction = (result) => {
    return {
        type: action.GET_ALL_TEMPLATES_SUCCESS,
        status: 'Templates retrieved sucessfully',
        result,
        requestState: false,
    };
};

export const getAllTemplateFailureAction = (error) => {
    return {
        type: action.GET_ALL_TEMPLATES_FAILURE,
        status: 'Get Templates failure',
        error,
        requestState: false,
    };
};

export const createTemplateRequestAction = (body) => {
    return {
        type: action.CREATE_TEMPLATE_REQUEST,
        status: 'CREATE__TEMPLATES_REQUEST',
        payload:{
            body
        },
        requestState: true,
    };
};

export const createTemplateSuccessAction = (result) => {
    return {
        type: action.CREATE_TEMPLATE_SUCCESS,
        status: 'Template created sucessfully',
        result,
        requestState: false,
    };
};

export const createTemplateFailureAction = (error) => {
    return {
        type: action.CREATE_TEMPLATE_FAILURE,
        status: 'Template creation failure',
        error,
        requestState: false,
    };
};